<template>
  <ThreeColumn :breadcrumbPaths="paths">
    <template v-slot:title>  
      <h1 class="text-h1 mb-0">{{$t('feedback.page_title')}}</h1>
    </template>

    <template v-slot:mainPanel>
      <div>
        <p>{{$t('feedback.feedback[0]')}}</p>
        <p v-html="$t('feedback.feedback[1]')"></p>
      </div>

      <br>

      <v-form
        cols="12" sm="10"
        ref="form"
        v-model="valid"
        lazy-validation
      >
        <v-text-field
          v-model="email"
          :rules="emailRules"
          :label="$i18n.t('feedback.email')"
          required
          color="link"
        ></v-text-field>

        <br>

        <v-textarea
          name="input-7-1"
          filled
          :label="$i18n.t('feedback.comment')"
          auto-grow
          v-model="feedback"
          color="link"
        ></v-textarea>

        <v-row class="px-3">
          <v-spacer v-if="$vuetify.breakpoint.mdAndUp"></v-spacer>
          <v-btn
            :disabled="!valid || clicked"
            color="navlink"
            class=" white--text"
            @click="send_feedback"
            large
            tile elevation="0"
            min-width="140"
            :block="$vuetify.breakpoint.xsOnly"
          >
            <v-icon small class="mr-4"> mdi-email-fast-outline </v-icon>
            {{$t('btntxt.submit')}}
          </v-btn>
        </v-row>
      </v-form>
      <br><br><br>
      <v-divider></v-divider>

      <!--Disclaimers-->
      <div>
        <h4 class="text-h4 mt-6 mb-3">{{$t('feedback.disclaimers_tag')}}</h4>
        <p>{{$t('feedback.disclaimers[0]')}}</p>
        <p>{{$t('feedback.disclaimers[1]')}}</p>
        <p class="pt-3 font-weight-bold darkgrey--text" v-html="$t('feedback.close')"></p>
      </div>

      <br><br>
    </template>
      
    <v-overlay :value="overlay">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
  </ThreeColumn>
</template>

<script>
  import api from '@/scripts/api'
  import ThreeColumn from '@/components/applayout/ThreeColumn'
  export default {
    name:'Feedback',
    components:{
      ThreeColumn
    },
    data(){
      return {
        overlay: false,
        valid: true,
        clicked: false,
        email: '',
        emailRules: [
          v => !!v || 'E-mail is required',
          v => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || 'E-mail must be valid',
        ],
        feedback: '',
        source: '',
      }
    },
    methods:{
      validate () {
        this.$refs.form.validate()
      },
      async send_feedback(){
        this.clicked = true
        try {
          await this.$recaptchaLoaded()
          const token = await this.$recaptcha('login')
          if (this.email){
            this.overlay = true
            const payload = {
              'sender': this.email,
              'body': this.feedback + this.source,
              'token': token
            }
            await api.sendFeedback(payload)
            this.$router.push({name:'feedback-success'})
          }
        } catch (err) {
          window.alert("Please try again later.")
          console.error(err)
        }
      }
    },
    computed: {
      paths(){
        return [
          {text: 'HKLII', disabled: false, href: {name: 'home'}},
          {text: this.$i18n.t('feedback.page_title'), disabled: true}
        ]
      }
    },
    mounted() {
      //window.document.title = this.$i18n.t('feedback.page_title') + ' | HKLII'
      this.source = this.$route.query.source ? `\n(Redirected from ${this.$route.query.source})` : ''
    },
    metaInfo(){
      return{
        title: this.$i18n.t('feedback.page_title'),
      }
    },
  }
</script>